<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form id="warranty-form">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="CompanyName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('CompanyName')">{{
          errors.first("CompanyName")
        }}</span>

        <vs-textarea
          v-model="model.description"
          name="Description"
          :label="$t('Description')"
          rows="1"
        />

        <div class="vx-row mb-4" v-if="uploadArea">
          <div class="vx-col  sm:w-1/4 w-full">
            <div class="uploader-box">
              <my-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="showUploader"
                :width="100"
                :height="100"
                langType="fa"
                :noCircle="true"
                img-format="jpg"
              ></my-upload>
              <img
                :src="URLS_CONSTANTS.assets + 'Guaranty/' + model.logoUri"
                v-if="model.logoUri && !model.logoUri.includes('base64')"
              />
              <img :src="uploadedImage" v-if="uploadedImage" />
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="removeUriImg"
                class="d-inline removeIco"
                v-if="model.logoUri"
              ></vs-button>
            </div>
            <!--{{  !model.logoUri.indexOf('data') !== -1}}-->
            <a class="uploadImg  img-box" @click.prevent="toggleShow">
              <i class="material-icons notranslate">
                cloud_upload
              </i>
              {{ $t("LogoImage") }}
            </a>
          </div>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<style>
#warranty-form .uploader-box > img {
  top: 0;
  -webkit-transform: unset;
  transform: unset;
}

.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import myUpload from "vue-image-crop-upload";

const dict = {
  custom: {
    CompanyName: {
      required: "لطفا نام شرکت را وارد نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {}
    }
  },
  data() {
    return {
      CompanyName: "",
      popupTitle: "",
      showUploader: false,
      uploadArea: true,
      disabled: false,
      uploadedImage: null,
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      createWarranty: "warranty/create",
      updateWarranty: "warranty/update"
    }),
    cropSuccess(imgDataUrl, field) {
      ///   this.model.logoUri = imgDataUrl;
      this.uploadedImage = imgDataUrl;
    },
    toggleShow() {
      this.showUploader = !this.showUploader;
    },
    removeUriImg() {
      this.model.logoUri = "";
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.model.logoUri = this.uploadedImage;
          this.uploadedImage = null;
          if (this.model.id != null) {
            this.updateWarranty(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createWarranty(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          this.$swal({
            position: "center-center",
            type: "error",
            text: "خطا",
            showConfirmButton: false,
            timer: 8000
          });
        }
      });
    }
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.parent != null) {
          this.uploadArea = false;
        } else {
          this.uploadArea = true;
        }
        if (this.model.id) {
          this.popupTitle = this.model.parent ? "EditWarranty" : "EditCompany";
        } else {
          this.popupTitle = this.model.parent
            ? "CreateNewTypeAndTermsOfWarranty"
            : "CreateNewCompany";
          this.model.logoUri = "";
        }
      }
      this.$validator.reset();
    }
  },
  components: {
    "my-upload": myUpload
  }
};
</script>
